<template>
  <!-- 閉じ括弧の前に空白を入れないため、タグの間で改行しない -->
  <span data-testid="sensor-last-reception"
    >{{ receivedAt }}<template v-if="signalStrength"
      >{{ $t('paren.open') }}<signal-strength-indicator
        :signal-strength="signalStrength"
        size="16"
      />{{ $t('paren.close') }}</template
  ></span>
</template>

<i18n lang="yaml">
ja:
  paren:
    open: '（'
    close: '）'
en:
  paren:
    open: ' ('
    close: ')'
</i18n>

<script>
import SignalStrengthIndicator from '@/components/atoms/SignalStrengthIndicator';
import { formatDateTime } from '@/mixins/dateTimeFormatting';
import { sensorHasCapability } from '@/mixins/sensorTypes';

// 最終受信日時と、その時点の通信強度を「日時（強度）」の 1 行で表す。
// 通信強度は最後に受信したときの値で、今の電波状態ではないため、日時に添えて出す。
// 一度も受信していないセンサーで何を出すかは画面ごとに異なるため、呼び出し側で出し分ける。
export default {
  name: 'sensor-last-reception',
  components: {
    SignalStrengthIndicator,
  },
  props: {
    sensor: {
      type: Object,
      required: true,
    },
    // 休止中のモニタリングポイントでは通信強度を出さない。休止の判定は呼び出し側で行う。
    showsSignalStrength: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    receivedAt() {
      return formatDateTime(this.sensor.last_event_request_time);
    },
    // 通信強度を持たない機種と、まだ一度も取得できていないセンサーでは括弧ごと出さない。
    signalStrength() {
      if (!this.showsSignalStrength || !sensorHasCapability(this.sensor, 'hasSignalStrength')) {
        return null;
      }
      return this.sensor.signal_strength != null ? this.sensor.signal_strength : null;
    },
  },
};
</script>
